function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #b4b4b4;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Past",
  d: "M61,37h9L63,56H54Z",
  transform: "translate(-26 -36.5)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Past-2",
  "data-name": "Past",
  className: "cls-2",
  d: "M47,37h9L49,56H40Z",
  transform: "translate(-26 -36.5)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Past-3",
  "data-name": "Past",
  className: "cls-3",
  d: "M33,37h9L35,56H26Z",
  transform: "translate(-26 -36.5)"
});

function SvgIconLogoMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_logo_mini",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 20,
    viewBox: "0 0 44 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoMini);
export default __webpack_public_path__ + "static/media/icon_logo_mini.e1eb4a2b.svg";
export { ForwardRef as ReactComponent };